<template>
  <v-autocomplete
    v-model="searchModel"
    :items="stocks"
    :search-input.sync="search"
    hide-no-data
    hide-selected
    item-text="product.name"
    item-value="id"
    label="Denumire"
    placeholder="Cauta produs"
    prepend-icon="search"
    no-filter
    return-object
    @change="selectProduct"
    :rules="requiredRules"
  >
    <template v-slot:item="{ item }">
      <v-list-item-avatar
        color="indigo"
        class="text-h5 font-weight-light white--text"
      >
        {{ item.product.name.charAt(0) }}
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-text="item.product.name"></v-list-item-title>
        <v-list-item-subtitle>
          Cod: {{ item.product.code }} /
          Pret: {{item.product.sellPrice}} RON /
          Cantitate: {{ item.quantity }} {{ item.product.units }} /
          {{new Date(item.date).toISOString().substr(0, 10),}}
        </v-list-item-subtitle
        >
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ProductSearch',
  props: ['product'],
  data() {
    return {
      search: '',
      searchModel: null,
      stocks: [{
        id: 0,
        name: ''
      }],
      requiredRules: [
        (element) => {
          if (!element) return 'Campul trebuie completat.';
          return true;
        },
      ],
    };
  },

  watch: {
    async search(query) {
      this.stocks = await this.searchProduct(query);
    },
  },

  methods: {
    ...mapActions('stocks', ['searchProduct']),

    selectProduct() {
      this.$emit('update:product', {
        ...this.product,
        stock: this.searchModel,
        productId: this.searchModel.product.id,
        stockId: this.searchModel.id,
        name: this.searchModel.product.name,
        um: this.searchModel.product.units,
        price: Number(this.searchModel.product.sellPrice),
      });
    },
  },
};
</script>
